import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_SUPPORT,
  GET_SUPPORT_DETAILS,
  ADD_NEW_SUPPORT,
  UPDATE_SUPPORT,
  DELETE_SUPPORT,
  EXPORT_SUPPORT,
} from "./actionTypes.js";

import {
  getSupportSuccess,
  getSupportFail,
  getSupportDetailsSuccess,
  getSupportDetailsFail,
  addSupportFail,
  addSupportSuccess,
  updateSupportSuccess,
  updateSupportFail,
  deleteSupportSuccess,
  deleteSupportFail,
  exportSupportSuccess,
  exportSupportFail,
} from "./action.js"

import {
  supportListingApi,
  supportDetailsApi,
  addNewSupport,
  updateSupport,
  delSupport,
  exportSupport,
} from "./supportApi.js"

function* fetchSupport({ payload: support }) {
  try {
    const response = yield call(supportListingApi, support)
    yield put(getSupportSuccess(response))
  } catch (error) {
    yield put(getSupportFail(error))
  }
}

function* fetchSupportDetails({ payload: id }) {
  try {
    const response = yield call(supportDetailsApi, id)
    yield put(getSupportDetailsSuccess(response))
  } catch (error) {
    yield put(getSupportDetailsFail(error))
  }
}

function* onAddNewSupport({ payload: support }) {
  try {
    const response = yield call(addNewSupport, support)
    yield put(addSupportSuccess(response))
  } catch (error) {
    yield put(addSupportFail(error))
  }
}

function* onUpdateSupport({ payload: id, support }) {
  try {
    const response = yield call(updateSupport, id, support)
    yield put(updateSupportSuccess(response))
  } catch (error) {
    yield put(updateSupportFail(error))
  }
}

function* onDelSupport({ payload: id }) {
  try {
    const response = yield call(delSupport, id)
    yield put(deleteSupportSuccess(response))
  } catch (error) {
    yield put(deleteSupportFail(error))
  }
}

function* onExportSupport({payload}) {
  try {
    const response = yield call(exportSupport, payload)
    yield put(exportSupportSuccess(response))
  } catch (error) {
    yield put(exportSupportFail(error))
  }
}

function* SupportSaga() {
  yield takeEvery(GET_SUPPORT, fetchSupport)
  yield takeEvery(GET_SUPPORT_DETAILS, fetchSupportDetails)
  yield takeEvery(ADD_NEW_SUPPORT, onAddNewSupport)
  yield takeEvery(UPDATE_SUPPORT, onUpdateSupport)
  yield takeEvery(DELETE_SUPPORT, onDelSupport)
  yield takeEvery(EXPORT_SUPPORT, onExportSupport)
}

export default SupportSaga
